import { Eye, EyeOff } from 'lucide-react';
import { IconButton } from '@mui/material';
import React from 'react';

interface VisibilityToggleProps {
  visible: boolean;
  onToggle: () => void;
}

export const VisibilityToggle: React.FC<VisibilityToggleProps> = ({
  visible,
  onToggle,
}) => {
  return (
    <IconButton
      size="small"
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
    >
      {visible ? <Eye size={16} /> : <EyeOff size={16} />}
    </IconButton>
  );
};
